import SimpleHeaderLayout from './SimpleHeaderLayout';

export default SimpleHeaderLayout;
